import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { ProfileDetailsModel } from 'app/core/model/profileDetailsModel';
import { BusinessManagmentService } from 'app/core/services/business-managment.service';
import { BusinessManagment } from 'app/public/model/BusinessManagment';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { Language, ResolutionType } from 'app/shared/model/enums';
import { CommonService } from 'app/shared/services/common.service';
import { AppResolutionType } from 'app/shared/common/appResolution';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-business-details',
  templateUrl: './business-details.component.html',
  styleUrl: './business-details.component.scss'
})
export class BusinessDetailsComponent implements OnInit {
  id: number;
  businessName: string
  @Input()
  business: BusinessManagment;
  items: MenuItem[] = [];
  activeItem :MenuItem; 
  icon: string = 'pi pi-arrow-right';
  currentLang;
  profileDetailsModel: ProfileDetailsModel = null
  AppResolutionType = AppResolutionType;
  ResolutionType = ResolutionType;
  activeRoute: string = 'details';

  navItems = [
    { route: 'details',        icon: 'pi pi-id-card',    labelKey: 'BUSINESS_MANAGEMENT.BUSINESS_DETAILS' },
    { route: 'leads',          icon: 'pi pi-users',      labelKey: 'BUSINESS_MANAGEMENT.LEADS_BUSINESS' },
    { route: 'subscriptions',  icon: 'pi pi-sync',       labelKey: 'BUSINESS_MANAGEMENT.SUBSCRIPTIONS_BUSINESS' },
    { route: 'payments',       icon: 'pi pi-wallet',     labelKey: 'BUSINESS_MANAGEMENT.PAYMENTS_BUSINESS' },
  ];

  constructor(private route: ActivatedRoute, private router: Router, private commonService: CommonService,
    private localizationService: LocalizationService, private businessManagment: BusinessManagmentService,   
     store: Store<AppState>,
    
  ) {
     store.select(selectLanguageInCommonState).subscribe(language => {
      this.currentLang = Language[language];
    })
  }
  ngOnInit(): void {
    this.id = Number(this.route.snapshot.paramMap.get('id'));
    this.businessManagment.getSpecificBusinessDetails({ BussinessId: this.id }).subscribe((res: any) => {  
      this.profileDetailsModel = res;
      this.businessName = this.profileDetailsModel.BusinessDetails.BusinessName    
      this.commonService.changeCurrentPageHeader(this.businessName);
    },
      err => {
        console.log(err);
      })
    this.initItems();
     this.activeItem = this.items[0]; 
    this.updateArrowIcon(this.currentLang);
    this.route.firstChild?.url.subscribe(url => {
      if (url?.length) this.activeRoute = url[0].path;
    });
  }
    updateArrowIcon(lang: string) {
    if (lang === 'en') {
      this.icon = 'pi pi-arrow-left';
    } else {
      this.icon = 'pi pi-arrow-right';
    }
  }
  backToAllBusinesses(){
  this.router.navigate(['/webplatform/businessManagment'])
  }
  navigateTo(routePath: string) {
    this.activeRoute = routePath;
    this.router.navigate([routePath], { relativeTo: this.route });
  }
  initItems() {
    this.items = this.navItems.map(item => ({
      label: this.localizationService.Translate(item.labelKey),
      icon: item.icon,
      command: () => this.navigateTo(item.route),
    }));
  }
}
